<template>
  <IndexPageSection
    v-if="showableGifteeColumns"
    :link-string="'一覧へ'"
    :link-url="'/announcements/giftee_columns'"
    :need-to-move-link-to-bottom="false"
    :section-name="'giftee-column-list-section'"
    :title="'ギフトコラム'"
    @click-link="onClickSectionHeaderLink"
  >
    <HorizontalScroll
      ref="giftee-column-list-horizontal"
      ref-name="giftee-column-list"
    >
      <GifteeColumnList
        :giftee-columns="gifteeColumns"
        @mount="onMountGifteeColumnList"
      />
    </HorizontalScroll>
  </IndexPageSection>
</template>
<script>
import IndexPageSection from './IndexPageSection.vue'
import GifteeColumnList from './giftee_columns/GifteeColumnList.vue'
import axios from 'axios'
import HorizontalScroll from '../../../molecules/horizontal-scrolls/HorizontalScroll.vue'
export default {
  components: { HorizontalScroll, IndexPageSection, GifteeColumnList },
  data() {
    return {
      gifteeColumns: [],
      isLoading: false
    }
  },
  computed: {
    isNotEmptyGifteeColumns() {
      return this.gifteeColumns.length !== 0
    },
    showableGifteeColumns() {
      return !this.isLoading && this.isNotEmptyGifteeColumns
    }
  },
  mounted() {
    this.getGifteeColumns()
  },
  methods: {
    onClickSectionHeaderLink() {
      dataLayer.push({
        event: 'click_top__column_list'
      })
    },
    async getGifteeColumns() {
      this.isLoading = true
      try {
        const res = await axios.get(
          '/api/v1/pickup/announcements/giftee_columns?limit=10'
        )
        this.gifteeColumns = res.data.data.map(gifteeColumn => ({
          id: gifteeColumn.attributes.id,
          imageUrl: gifteeColumn.attributes.top_image_url,
          title: gifteeColumn.attributes.title
        }))
      } catch (error) {
        const message =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '情報の取得に失敗しました。しばらく経ってから再度アクセスしてください'
        this.$emit('error', message)
      }
      this.isLoading = false
    },
    onMountGifteeColumnList() {
      this.$refs['giftee-column-list-horizontal'].initializeValues()
    }
  }
}
</script>
<style lang="scss">
.home-container {
  .giftee-column-list-section {
    @extend %top-section;

    &__container {
      @extend %top-section__container;
      padding-bottom: 24px;
    }

    &__head {
      @extend %top-section__head;
    }

    &__title {
      @extend %top-section__title;
    }
  }
}
</style>
